import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import { IntegrationEntitySyncTag } from "components";
import { ITableV2Column } from "components/table-v2/table-v2";
import { DefaultHeaderCell } from "components/table-v2/header-cells";
import { DefaultRowCell } from "components/table-v2/row-cells";
import { TAltoSyncLeadSourceExtendedData } from "types/alto.type";
import { AltoLeadSourceSyncSelect } from "./AltoLeadSourceSyncSelect";

export const syncAltoLeadSourceTableColumnDef = (
  accountStore: UserAccountStore,
  updateSyncPair: (syncPair: TAltoSyncLeadSourceExtendedData) => void
): ITableV2Column<TAltoSyncLeadSourceExtendedData>[] => {
  return [
    {
      accessor: "leadSourceName",
      Header: <DefaultHeaderCell>LeadPro source</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell textTransform={"capitalize"}>
          {row.leadSourceName}
        </DefaultRowCell>
      ),
    },
    {
      accessor: "altoId",
      excludeFromGlobalFilter: true,
      disableSortBy: true,
      Header: <DefaultHeaderCell>Alto source</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell>
          <AltoLeadSourceSyncSelect
            accountStore={accountStore}
            onChange={updateSyncPair}
            record={row}
          />
        </DefaultRowCell>
      ),
    },
    {
      accessor: "syncStatus",
      excludeFromGlobalFilter: true,
      Header: <DefaultHeaderCell>Status</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell>
          <IntegrationEntitySyncTag syncStatus={row.syncStatus} />
        </DefaultRowCell>
      ),
    },
  ];
};
